import { Controller } from 'react-hook-form';
import { Box, Checkbox, FormControlLabel } from '@mui/material';
import { FC, useEffect } from 'react';
import { TradingFormField } from './trading-form-field';
import { useTradingFormContext } from './trading-form-context';
import { FormContainer } from '../../foundation/layout/form-container';
import { FieldWrapper } from '../../foundation/layout/field-wrapper';
import { ExchangeId, TradingMode } from '@shared/types';
import { extractSymbolAndTimeframe } from '../chart/utils/file.util';
import { useTemplates } from '@client/features/trading-templates/create-template/templates.hook';

type MarketConfigFormProps = { mode: TradingMode };

export const MarketConfigForm: FC<MarketConfigFormProps> = ({ mode }) => {
  const { control, setValue, watch } = useTradingFormContext();
  useTemplates({ type: 'market', path: 'marketConfig', mode });
  const { exchangeId, tradingMode, useExchangeData, testnet, simulation } =
    watch('marketConfig') || {};

  const timeframes = watch('timeframes');

  const file = timeframes?.[0]?.file;

  useEffect(() => {
    if (!file) return;

    const { symbol, timeframe } = extractSymbolAndTimeframe(file.name);

    if (symbol && timeframe) {
      setValue('marketConfig.symbol', symbol);
    }
  }, [file, setValue]);

  return (
    <Box>
      <FormContainer>
        {/* Exchange Selector */}
        <TradingFormField
          type="exchange"
          name="marketConfig.exchangeId"
          onChange={(_, newValue) =>
            setValue('marketConfig.exchangeId', newValue as ExchangeId)
          }
        />
        <>
          <TradingFormField
            type="symbol"
            // control={control}
            name="marketConfig.symbol"
            exchangeId={exchangeId}
          />
        </>

        {tradingMode === 'BACKTESTING' && (
          <>
            {/* Live Simulation Checkbox */}
            <FieldWrapper sx={{ flexDirection: 'row' }}>
              <FormControlLabel
                control={
                  <Controller
                    name="marketConfig.simulation"
                    control={control}
                    render={({ field }) => (
                      <Checkbox {...field} checked={simulation} />
                    )}
                  />
                }
                label="Live Simulation"
                sx={{ display: 'block', textAlign: 'center', mt: 0.4 }}
              />
            </FieldWrapper>

            {/* Use Exchange Data Checkbox */}
            <FieldWrapper sx={{ flexDirection: 'row' }}>
              <FormControlLabel
                control={
                  <Controller
                    name="marketConfig.useExchangeData"
                    control={control}
                    render={({ field }) => (
                      <Checkbox {...field} checked={useExchangeData} />
                    )}
                  />
                }
                label="Use Exchange Data"
                sx={{ display: 'block', textAlign: 'center', mt: 0.4 }}
              />
            </FieldWrapper>
          </>
        )}

        {/* Testnet */}
        {(tradingMode === 'LIVE' || useExchangeData) && (
          <FieldWrapper>
            <FormControlLabel
              control={
                <Controller
                  name="marketConfig.testnet"
                  control={control}
                  render={({ field }) => (
                    <Checkbox {...field} checked={!!testnet} />
                  )}
                />
              }
              label="Demo trading"
              // sx={{ display: "block", textAlign: "center", mt: 0.4 }}
            />
          </FieldWrapper>
        )}
      </FormContainer>
    </Box>
  );
};
